import { t } from '@lingui/core/macro'
import { Button, Loading, Modal } from '@tecsinapse/cortex-react'
import React from 'react'
import type { ConfirmModalProps } from '@/core/types/confirm-modal'
import useConfirmHelpers from '../hooks/use-confirm-helpers'
import { useModalOverflowHidden } from '../hooks/use-modal-overflow-hidden'

const ConfirmModal = <T,>({
  open,
  setOpen,
  title,
  subtitle,
  confirmLabel,
  cancelLabel,
  onCancel,
  onConfirm,
  errorMessage,
  successMessage,
  children
}: ConfirmModalProps<T> & {
  open: boolean
  setOpen: (state: boolean) => void
}) => {
  const { loading, onClose, handleCancel, handleConfirm } = useConfirmHelpers(
    setOpen,
    onConfirm,
    onCancel,
    successMessage,
    errorMessage
  )

  useModalOverflowHidden({ open })

  return (
    <Modal open={open} onClose={onClose}>
      <div
        className={'flex flex-col items-center text-h3 font-bold space-y-deca'}
      >
        <p>{title ?? t`Você tem certeza?`}</p>
        {subtitle ? <p className={'font-medium text-h4'}>{subtitle}</p> : null}
        {children}
        <div
          className={
            'flex flew-row justify-between items-center space-x-deca w-full'
          }
        >
          <Button
            variants={{ variant: 'outline', className: 'flex-1' }}
            onClick={handleCancel}
            disabled={loading}
          >
            <p>{cancelLabel ?? t`Cancelar`}</p>
          </Button>
          <Button
            variants={{ className: 'flex-1 items-center' }}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? <Loading className='mr-mili' /> : null}
            {confirmLabel ?? t`Confirmar`}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmModal
